module.exports = __webpack_public_path__ + "static/img/Store-10.7d1d5853.png";